import { List } from 'antd';
import { observer } from 'mobx-react-lite';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { MasterDetailsAside } from 'src/components/MasterDetailsPage/MasterDetailsAside';
import { MasterDetailsPage } from 'src/components/MasterDetailsPage/MasterDetailsPage';
import { BorrowerListItem } from 'src/pages/BorrowersPage/BorrowerListItem';
import { BorrowersHeaderPanel } from 'src/pages/BorrowersPage/BorrowersHeaderPanel';
import {
    BorrowerItemDetails,
    BorrowersStore,
} from 'src/stores/BorrowersStore/BorrowersStore';

export const BorrowersPage = observer(() => {
    return (
        <MasterDetailsPage
            pageName="borrowers"
            store={store}
            asidePanel={<BorrowersAsidePanel />}
            data-testid="borrowers-page"
        >
            <EntityPresentation store={store} entityName="borrower" />
        </MasterDetailsPage>
    );
});

const BorrowersAsidePanel = observer(() => {
    return (
        <MasterDetailsAside
            store={store}
            renderItem={(borrower: BorrowerItemDetails) => {
                return (
                    <List.Item
                        key={borrower.taxNumber}
                        data-testid={`master-details-list-item-${borrower.id}`}
                    >
                        <BorrowerListItem borrower={borrower} />
                    </List.Item>
                );
            }}
            header={<BorrowersHeaderPanel />}
        />
    );
});

const store = BorrowersStore;
